export const USER_CONSENTS = { consents: 'blt85180032582b7115' };
export const USER_CONSENTS_REBRAND = { consents: 'bltd6a0743f1b6abdd2' };
export const USER_CONSENTS_PSA = { consents: 'bltd82cfb1bcf36913d' };
export const USER_CONSENTS_UPDATE = { consents: 'blt872c40e80eab36d8' };
export const USER_CONSENTS_UPDATE_REBRAND = { consents: 'bltedab229f230ff9b9' };
export const USER_CONSENTS_PSA_GEN_CONSENT= { consents: 'blt9813c50f8ff43587' };
export const USER_CONSENTS_PSA_PRIVACY_SETTINGS= { consents: 'blt22131d0d09f3adda' };
export const PRINTER_CONSENTS = { consents: 'bltc63f900e5a7e7e6d' };
export const PRINTER_CONSENTS_UPDATE = { consents: 'blt6c33092d365998ee' };
export const PRINTER_CONSENTS_UPDATE_REBRAND = { consents: 'bltd087ffb9d7f861d5' };
export const PRINTER_CONSENTS_UPDATE_REBRAND_LINKS = { page_links: 'bltb1e4778692dbf13b' };
export const PRINTER_CONSENTS_REBRAND = { consents: 'bltc63f900e5a7e7e6d' };
export const USER_CONSENTS_EASYSTART = { consents: 'bltf7708286081309f0' };
export const USER_CONSENTS_EASYSTART_UPDATE = { consents: 'blt7de257904bd76c7b' };
export const USER_CONSENTS_EASYSTART_MODIFY_CONSENT = { consents: 'blta5d3099712f80d2f' };
export const USER_CONSENTS_EASYSTART_PRO = { consents: 'blt5b77e0ccafef0738' };
export const USER_CONSENTS_EASYSTART_PRO_UPDATE = { consents: 'bltbc17170e647f82cb' };
export const WJA_CONSENTS = { consents: 'blt893041f9cced5b8a' };
export const WJA_CONSENTS_UPDATE = { consents: 'blt33cdbfcaa4b6f98d' };
export const USER_CONSENTS_SURE_SUPPLY = { consents: 'bltab8d4958de22aca8' };
export const WORK_FROM_HOME_PRINTER = { consents: 'blt5d62edd4aa025d8a' };
export const WORK_FROM_HOME_PRINTER_REBRAND = { consents: 'blt41a4675835bea6b7' };
export const COMPANY_TENANT_PRINTER = { consents: 'bltbdf8cbd7458eed1b' };
export const NEW_USER = { consents: 'bltd3a57336292ce9be' };
export const RETURNING_USER = { consents: 'blt6a1cb510e06f7620' };
export const PRINTER_WELCOME = { consents: 'bltf9e690645cbcdbeb' };
